'use strict';

require('../shared/base-entry');
require('./views/top-offers');
require('../shared/post-entry');
